import { render, staticRenderFns } from "./validationtask-reopen-modal.vue?vue&type=template&id=028da260&scoped=true"
import script from "./validationtask-reopen-modal.vue?vue&type=script&lang=js"
export * from "./validationtask-reopen-modal.vue?vue&type=script&lang=js"
import style0 from "./validationtask-reopen-modal.vue?vue&type=style&index=0&id=028da260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028da260",
  null
  
)

export default component.exports